import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from '../ui/alert-dialog';
import { useTranslation } from '../../hooks/useTranslation';

// Compartido entre LeadDetail.js (individual, count=1) y LeadScannerPage.js
// (lote, count=N seleccionados) — mismo diálogo, deja explícito que
// "Descartar" es un borrado suave (status=DISCARDED), no un borrado real:
// el propio texto lo dice para que Marta no dude de si es reversible.
export function DiscardLeadsDialog({ open, onOpenChange, count, onConfirm, confirming }) {
  const { t } = useTranslation();

  // AlertDialogAction (Radix) cierra el diálogo automáticamente al pulsar
  // — preventDefault() lo evita, para que el diálogo siga abierto con el
  // spinner mientras onConfirm() (async, llamadas HTTP reales) termina.
  // El propio onConfirm es quien decide cuándo cerrar (onOpenChange(false)).
  const handleConfirmClick = (e) => {
    e.preventDefault();
    onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('aiLeadScanner.discardDialog.title', { count })}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('aiLeadScanner.discardDialog.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={confirming}>
            {t('aiLeadScanner.leadDetail.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirmClick} disabled={confirming} data-testid="confirm-discard">
            {confirming && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />}
            {t('aiLeadScanner.discardDialog.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
